import { Link } from 'react-router-dom';
import { hotArticles } from '@/mocks/home';

function formatViews(n: number): string {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return String(n);
}

export default function HotRecommend() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              最受欢迎的凪光系列内容，不容错过
            </p>
          </div>
          <Link
            to="/category/anime"
            className="whitespace-nowrap hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {hotArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 border border-background-200 hover:border-primary-200 rounded-lg overflow-hidden transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={article.cover}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="whitespace-nowrap px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                    {article.category}
                  </span>
                </div>
                {article.rating > 0 && (
                  <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 rounded-full bg-black/50 backdrop-blur-sm text-white text-xs">
                    <i className="ri-star-fill text-accent-400 text-xs"></i>
                    {article.rating}
                  </div>
                )}
              </div>
              <div className="p-4">
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.description}
                </p>
                <div className="mt-3 flex items-center gap-4 text-xs text-foreground-400">
                  {article.episodes > 1 && (
                    <span className="flex items-center gap-1">
                      <i className="ri-play-list-2-line"></i>
                      {article.episodes}话
                    </span>
                  )}
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {formatViews(article.views)}次播放
                  </span>
                  <span className={`whitespace-nowrap ml-auto px-2 py-0.5 rounded text-xs ${
                    article.status.includes('完结') || article.status.includes('上映') || article.status.includes('发售') || article.status.includes('发布')
                      ? 'bg-secondary-100 text-secondary-700'
                      : 'bg-primary-100 text-primary-700'
                  }`}>
                    {article.status}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}